import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddIcon from "@material-ui/icons/Add";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import { GridInput } from "components/GridForm";
import { NumberInputEx } from "components/inputs";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { PalletReservationType } from "entities/PalletReservationType";
import React from "react";
import {
	AutocompleteInput,
	ReferenceInput,
	required,
	useMutation,
	useNotify,
	useTranslate,
} from "react-admin";
import { Form } from "react-final-form";
import { useNotifyError } from "utils/notifiers/useNotifyError";
import { validatePositiveNumber } from "utils/validation/general";

export const ReserveModal = (props) => {
	const notify = useNotify();
	const notifyError = useNotifyError();
	const translate = useTranslate();
	const { open, handleOpen, handleClose } = useSimpleModalToggle();

	const [create, { loading }] = useMutation(
		{
			type: "create",
			resource: "automatic-pallets-reservation",
		},
		{
			onSuccess: () => {
				handleClose();
				props.refreshList();
				notify(translate("osfc.dialogs.pallets_reserve.success"), "success");
			},
			onFailure: (error) => {
				notifyError(error);
			},
		}
	);

	const handleSubmit = (values) => {
		const payload = {
			data: {
				...values,
			},
		};

		create({ payload });
	};

	return (
		<React.Fragment>
			<Button
				variant="contained"
				color="primary"
				onClick={handleOpen}
				// disabled={props.orderPallets < 1}
				style={{ marginRight: 10 }}
				startIcon={<AddIcon />}
				disabled={props.disabled}
			>
				{props.buttonText}
			</Button>
			{open && (
				<Dialog open={true} maxWidth="md" onClose={handleClose}>
					<DialogTitle>{translate("tab.picking_list.automatic_reserve.title")}</DialogTitle>
					<DialogContent>
						<Form
							onSubmit={handleSubmit}
							render={({ handleSubmit, submitting, pristine }) => (
								<form onSubmit={handleSubmit}>
									<GridInput
										md={12}
										component={SelectEnumInput}
										source="reservation_type"
										enumName="reservation-type"
										enumObj={PalletReservationType}
										validate={required()}
									/>
									<GridInput md={12}>
										<ReferenceInput
											validate={required()}
											source="product_name"
											reference="product-names"
											perPage={15}
											filter={{
												no_range: false,
												order_id: props.orderId,
											}}
										>
											<AutocompleteInput optionText="product_name" />
										</ReferenceInput>
									</GridInput>
									<GridInput
										md={12}
										component={NumberInputEx}
										source="quantity"
										step={1}
										validate={[validatePositiveNumber(translate)]}
									/>

									<DialogActions>
										<Button onClick={handleClose} color="primary" disabled={submitting}>
											{translate("ra.action.cancel")}
										</Button>
										<Button type="submit" color="primary" disabled={submitting || loading}>
											{translate("ra.action.reserve")}
										</Button>
									</DialogActions>
								</form>
							)}
						/>
					</DialogContent>
				</Dialog>
			)}
		</React.Fragment>
	);
};
